<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:new="createHandler"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
         v-on:cancel="cancelHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import ClaimRecordForm from "../../../components/claim/claimrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": ClaimRecordForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('claimrecordlisting.editclaimrecord'),
      pageTitleValue: "",
      formData: [],

      chargeItems: [],
      chargeList: [],
      chargecodes: [],
 
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    async loadClaimRecordHandler() {
      const vm = this;

      try {
          const res = await this.$store.dispatch('get', {url: "/claimrecord/" + this.id})

          vm.formData = res.data.rec[0];

          vm.formData.staffcode = res.data.rec[0].staffno;
          vm.formData.wftranid = res.data.rec[0].wftranid;
          vm.formData.clmtypdesc = res.data.rec[0].clmtypdesc;

           if (res.data.rec[0].entrytime) {
            vm.formData.entrytime = moment(res.data.rec[0].entrytime).format(
              "YYYY-MM-DD"
            );
          }
          

       //   vm.formData.grpvalueid = res.data.rec[0].grpvalueid;
          
          vm.formData.stamp = res.data.rec[0].stamp;
          vm.formData.lockstaff = res.data.rec[0].lockstaff;

          vm.formData.userid = this.$store.getters.userId;
          vm.pageTitleValue = res.data.rec[0].valuedesc;

          await this.loadClaimRecordDetailHandler();

       //  vm.loading = false;
        } catch(err) {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        }
    },

    loadClaimRecordDetailHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/claimrecorddetail/" + this.id})
        .then((res) => {
          vm.formData.claimrecorddetail = res.data.rec;
         
        for (let i = 0; i < res.data.rec.length; i++) {
            if (res.data.rec[i].receiptdate) {
              vm.formData.claimrecorddetail[i].receiptdate = moment(
                res.data.rec[i].receiptdate
              ).format("YYYY-MM-DD");
            }
          }
          

          for (let i = 0; i < vm.formData.claimrecorddetail.length; i++) {
            Object.assign(vm.formData.claimrecorddetail[i], {
              action: 2,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/claimrecord/" + vm.id,
          payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            if(this.formData.wftranid == null || this.formData.wftranid == 0){
              // if created by HR admin, no workflow involved, go back to list
              this.$router.push({ name: "claimrecordlist", params: { search: this.search } });
            }else{
              // if created by normal staff, need to update workflow transaction
              this.updateWfTran();
            }
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    async updateWfTran() {
      const vm = this;

      //For Approve 
      const approveList = this.formData.claimrecorddetail.filter(d => [2].includes(d.transtatusid));
      //For Reject
      const rejectList = this.formData.claimrecorddetail.filter(d => [3].includes(d.transtatusid));

      
      // console.log("formData to check for update wftran: ",this.formData);
      
      // Function to build payload for backend
      const buildPayload = (records) => {
        return records.map(d => {
          let apraction = d.transtatusid === 2 ? "APPROVE" : d.transtatusid === 3 ? "REJECT" : "CANCEL";
          return {
            recordid: d.id,
            wftranid: this.formData.wftranid,
            id: d.wftrandid,
            wftrandid: d.wftrandid,
            transtatusid: d.transtatusid,
            apraction,
            lvlno: d.lvlno,
            aprvremark: "",
            aprvamt: d.aprvamt ?? d.clmtotalamt ?? 0,
            aprvamtb4tax: d.aprvamtb4tax ?? 0,
            receiptaprvamt: d.receiptaprvamt ?? d.clmtotalamt ?? 0,
            receiptaprvamtb4tax: d.receiptaprvamtb4tax ?? 0,
            subrecid: d.id,                         // claimrecordd.id
            reqstaffid: this.formData.staffid,      // claim submitter
            aprid: this.$store.getters.staffId,
            staffid: this.formData.staffid,
            clmtypdesc: this.formData.clmtypdesc,
            clmtypecrcycode: d.clmtypecrcycode,
            entrytime: this.formData.entrytime,
            clmtotalamt: d.clmtotalamt
          };
        });
      };
    
    //For cancel
    const cancelList = this.formData.claimrecorddetail.filter(d => d.transtatusid === 4);

    try {
        // 1️⃣ Run final approve API first
        if (approveList.length > 0) {
          const apiUrl1 = `/finalapprovalworkflow/claim`;
          console.log("Sending approve:", buildPayload(approveList));
          await this.$store.dispatch('put', { url: apiUrl1, payload: buildPayload(approveList) });
        }

        //If reject maintain in the same API
        if (rejectList.length > 0) {
          const apiUrl1 = `/approvalworkflow/claim/${this.$store.getters.userId}/${this.formData.staffid}`;
          console.log("Sending reject:", buildPayload(rejectList));
          await this.$store.dispatch('put', { url: apiUrl1, payload: buildPayload(rejectList) });
        }

        // 2️⃣ Then run cancel API
        if (cancelList.length > 0) {
          const apiUrl2 = '/workflowtransaction/claimrecordcancellation';
          console.log("Sending cancellations:", buildPayload(cancelList));
          await this.$store.dispatch('put', { url: apiUrl2, payload: { 
            staffid: this.formData.staffid,
            claimrecorddList: buildPayload(cancelList)
          }});
        }

        // 3️⃣ Navigate back to list after both succeed
        this.$router.push({ name: "claimrecordlist", params: { search: this.search } });

      } catch (err) {
        vm.isErr = true;
        vm.errMsg = err;
      }
    },

    cancelHandler() {
      this.$router.push({ name: "claimrecordlist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:
            "/claimrecord/" +
            vm.id +
            "/" +
            this.formData.userid
        })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "claimrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "claimrecordnew" });
    },
  },

  async mounted() {
    await this.loadClaimRecordHandler();
  
  },
};
</script>